<template>
  <div>
    <el-dialog
      title="参数"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
      
    >
    <div >
      <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-magic-stick"
      @click="formatCode()">{{ this.isFormat?"美化":"还原" }}</el-button>
    </div>
    <el-form ref="form"  class="json-text" :model="form" label-width="0px" size="mini" style="width:950px;height:550px">
        <el-form-item label="" prop="parameter1">
          <el-input  v-model="form.parameter1" disabled type="textarea" :rows="30"  ></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

export default {
  data() {
    return {
      visible: true,
      form: {},
      tmpFormParameter:"",
      isFormat:true,
      isCreated: false,
      statusOptions: [
        {
          value: 0,
          label: "禁用",
        },
        {
          value: 1,
          label: "启用",
        }
      ],
    };
  },

  created() {
    this.form = this.value.info
    this.tmpFormParameter = this.value.info.parameter1
  },
  props: {
    value: Object,
  },
  components: {
  },

  methods: {
    formatCode(){
      if(this.isFormat){
        let tmpObj  = JSON.parse(this.tmpFormParameter)
        this.form.parameter1 = JSON.stringify(tmpObj, null, "    ")
      }else{
        this.form.parameter1 = this.tmpFormParameter
      }
      this.isFormat = !this.isFormat   
    },
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async settingActivityInOnline() {
      try {
        // 弹确认框
        await this.$confirm(`确认${this.isCreated?'新增':'编辑'}活动开关“${this.form.key}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/settingActivitySwitch`,
            {
              activitySwitch:this.form
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      } catch (e) {}
    },

    ms2ymdhm(ts) {
    return util.ms2ymdhm(ts);
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background-color: #FFF;
    border-color: #E4E7ED;
    color: #000000;
    cursor: not-allowed;
}
.paramCls{
  background-color: #080808;
  border-color: #E4E7ED;
  color: #000000;
}
</style>

